export const SET_TIMER = 'tick/SET_TIMER';
export const OFFSET = 'tick/OFFSET';
